<template>
  <v-container>
    <BracketTemplate
    v-bind:welcomeText = "welcomeText"
    v-bind:desc = "desc"
    v-bind:options = "options"
    ></BracketTemplate>
  </v-container>
</template>

<script>
  import BracketTemplate from '../../components/BracketTemplate';

  export default {
    name: 'celebBracket',
    components: {
      BracketTemplate,
    },
    data: () => ({
      welcomeText: "Welcome to celeb bracket SFW Edition!",
      desc: "You will be given two celebrities at random, select one of the two, and they will go on to the next round of the bracket!",
      options: [
        {
          src: 'https://i.imgur.com/6LIwNdk.jpg',
          name: 'Bella Hadid'
        },
        {
          src: 'https://i.imgur.com/QRv2ZyS.jpg',
          name: 'Amy Adams'
        },
        {
          src: 'https://i.imgur.com/O6eLDeT.jpg',
          name: 'Margot Robbie'
        },
        {
          src: 'https://i.imgur.com/fWrF4lM.jpg',
          name: ' Elizabeth Olsen'
        },
        {
          src: 'https://i.imgur.com/YOk9nsT.jpg',
          name: 'Alison Brie'
        },
        {
          src: 'https://i.imgur.com/Z4GNT91.jpg',
          name: 'Halle Berry'
        },
        {
          src: 'https://i.imgur.com/YZ8Tnp1.jpg',
          name: 'Emma Stone'
        },
        {
          src: 'https://i.imgur.com/toZ3bdw.jpg',
          name: 'Anne Hathaway'
        },
        {
          src: 'https://i.imgur.com/sI4gnfj.jpg',
          name: 'Alexandra Daddario'
        },
        {
          src: 'https://i.imgur.com/aD4O9qB.jpg',
          name: 'Kaley Cuoco'
        },
        {
          src: 'https://i.imgur.com/t6rxTab.jpg',
          name: 'Ashley Tisdale'
        },
        {
          src: 'https://i.imgur.com/lcwGs6k.jpg',
          name: 'Demi Lovato'
        },
        {
          src: 'https://i.imgur.com/1EnTZsy.jpg',
          name: 'Rita Ora'
        },
        {
          src: 'https://i.imgur.com/Z9uxUpI.jpg',
          name: 'Kirsten Dunst'
        },
        {
          src: 'https://i.imgur.com/JUKALZV.jpg',
          name: 'Daisy Ridley'
        },
        {
          src: 'https://i.imgur.com/dDvMzFn.jpg',
          name: 'Scarlett Johansson'
        },
        {
          src: 'https://i.imgur.com/MmUBAnY.jpg',
          name: 'Emma Roberts'
        },
        {
          src: 'https://i.imgur.com/UbpubXO.jpg',
          name: 'Ashley Benson'
        },
        {
          src: 'https://i.imgur.com/91SVjqI.jpg',
          name: 'Lesley-Ann Brandt'
        },
        {
          src: 'https://i.imgur.com/Bz8atjT.jpg',
          name: 'Sofia Vergara'
        },
        {
          src: 'https://i.imgur.com/0XOKzzy.jpg',
          name: 'Danica Patrick'
        },
        {
          src: 'https://i.imgur.com/CAAuQKb.jpg',
          name: 'Eva Longoria'
        },
        {
          src: 'https://i.imgur.com/qjZbSKg.jpg',
          name: 'Candice Swanepoel'
        },
        {
          src: 'https://i.imgur.com/3lsOGJd.jpg',
          name: 'Laura Elena Harring'
        },
        {
          src: 'https://i.imgur.com/toJDE9k.png',
          name: 'Kate Beckinsale'
        },
        {
          src: 'https://i.imgur.com/Fmh21Ag.jpg',
          name: 'Halsey'
        },
        {
          src: 'https://i.imgur.com/HCuBf5I.jpg',
          name: 'Evangeline Lilly'
        },
        {
          src: 'https://i.imgur.com/GJTPwOS.jpg',
          name: 'Rachel McAdams'
        },
        {
          src: 'https://i.imgur.com/KQSHsVM.jpg',
          name: 'Hilary Duff'
        },
        {
          src: 'https://i.imgur.com/ca1vJtr.jpg',
          name: 'Nicole Scherzinger'
        },
        {
          src: 'https://i.imgur.com/1xBAGYO.jpg',
          name: 'Trish Stratus'
        },
        {
          src: 'https://i.imgur.com/mKF3tBT.jpg',
          name: 'Megan Fox'
        },
      ]
    }),
    methods: {

    },
  }
</script>